import { IStore } from "reducers";
import { IState as IMerchantAllocationDimensionState } from "reducers/merchant-allocation-dimension";
import { RequestStatus } from "constants/crud";

export const getMerchantAllocationDimensionState = (state: IStore): IMerchantAllocationDimensionState => {
    return state.merchantAllocationDimension;
};

export const getMerchantAllocationDimensionList = (state: IStore) => {
    const merchantAllocationDimensionState = getMerchantAllocationDimensionState(state);
    return merchantAllocationDimensionState.list.result;
};

export const getMerchantAllocationDimensionListIsRequesting = (state: IStore) => {
    const merchantAllocationDimensionState = getMerchantAllocationDimensionState(state);
    return merchantAllocationDimensionState.list.queryStatus === RequestStatus.Active;
};
